export const furnitureLevelThree = [
  {
    "name": "Bed Runners",
    "categoryId": "bed_runners",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Mattress Protectors",
    "categoryId": "mattress_protectors",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Bedsheets",
    "categoryId": "bedsheets",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Bedding Sets",
    "categoryId": "bedding_sets",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Blankets, Quilts & Dohars",
    "categoryId": "blankets_quilts_dohars",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Pillows & Pillow Covers",
    "categoryId": "pillows_pillow_covers",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Bed Covers",
    "categoryId": "bed_covers",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Diwan Sets",
    "categoryId": "diwan_sets",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Chair Pads & Covers",
    "categoryId": "chair_pads_covers",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Sofa Covers",
    "categoryId": "sofa_covers",
    "parentCategoryName": "Bed Linen & Furnishing",
    "parentCategoryId": "bed_linen_furnishing",
    "level": 3
  },
  {
    "name": "Floor Runners",
    "categoryId": "floor_runners",
    "parentCategoryName": "Flooring",
    "parentCategoryId": "flooring",
    "level": 3
  },
  {
    "name": "Carpets",
    "categoryId": "carpets",
    "parentCategoryName": "Flooring",
    "parentCategoryId": "flooring",
    "level": 3
  },
  {
    "name": "Floor Mats & Dhurries",
    "categoryId": "floor_mats_dhurries",
    "parentCategoryName": "Flooring",
    "parentCategoryId": "flooring",
    "level": 3
  },
  {
    "name": "Door Mats",
    "categoryId": "door_mats",
    "parentCategoryName": "Flooring",
    "parentCategoryId": "flooring",
    "level": 3
  },
  {
    "name": "Bath Towels",
    "categoryId": "bath_towels",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Hand & Face Towels",
    "categoryId": "hand_face_towels",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Beach Towels",
    "categoryId": "beach_towels",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Towels Set",
    "categoryId": "towels_set",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Bath Rugs",
    "categoryId": "bath_rugs",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Bath Robes",
    "categoryId": "bath_robes",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Bathroom Accessories",
    "categoryId": "bathroom_accessories",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Shower Curtains",
    "categoryId": "shower_curtains",
    "parentCategoryName": "Bath",
    "parentCategoryId": "bath",
    "level": 3
  },
  {
    "name": "Floor Lamps",
    "categoryId": "floor_lamps",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "Ceiling Lamps",
    "categoryId": "ceiling_lamps",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "Table Lamps",
    "categoryId": "table_lamps",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "Wall Lamps",
    "categoryId": "wall_lamps",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "Outdoor Lamps",
    "categoryId": "outdoor_lamps",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "String Lights",
    "categoryId": "string_lights",
    "parentCategoryName": "Lamps & Lighting",
    "parentCategoryId": "lamps_lighting",
    "level": 3
  },
  {
    "name": "Plants & Planters",
    "categoryId": "plants_planters",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Aromas & Candles",
    "categoryId": "aromas_candles",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Clocks",
    "categoryId": "clocks",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Mirrors",
    "categoryId": "mirrors",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Wall Décor",
    "categoryId": "wall_decor",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Festive Decor",
    "categoryId": "festive_decor",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Pooja Essentials",
    "categoryId": "pooja_essentials",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Wall Shelves",
    "categoryId": "wall_shelves",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Fountains",
    "categoryId": "fountains",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Showpieces & Vases",
    "categoryId": "showpieces_vases",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Ottoman",
    "categoryId": "ottoman",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Cushions & Cushion Covers",
    "categoryId": "cushions_cushion_covers",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Curtains",
    "categoryId": "curtains",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Home Gift Sets",
    "categoryId": "home_gift_sets",
    "parentCategoryName": "Home Décor",
    "parentCategoryId": "home_decor",
    "level": 3
  },
  {
    "name": "Table Runners",
    "categoryId": "table_runners",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Dinnerware & Serveware",
    "categoryId": "dinnerware_serveware",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Cups and Mugs",
    "categoryId": "cups_mugs",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Bakeware & Cookware",
    "categoryId": "bakeware_cookware",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Kitchen Storage & Tools",
    "categoryId": "kitchen_storage_tools",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Bar & Drinkware",
    "categoryId": "bar_drinkware",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Table Covers & Furnishings",
    "categoryId": "table_covers_furnishings",
    "parentCategoryName": "Kitchen & Table",
    "parentCategoryId": "kitchen_table",
    "level": 3
  },
  {
    "name": "Bins",
    "categoryId": "bins",
    "parentCategoryName": "Storage",
    "parentCategoryId": "storage",
    "level": 3
  },
  {
    "name": "Hangers",
    "categoryId": "hangers",
    "parentCategoryName": "Storage",
    "parentCategoryId": "storage",
    "level": 3
  },
  {
    "name": "Organisers",
    "categoryId": "organisers",
    "parentCategoryName": "Storage",
    "parentCategoryId": "storage",
    "level": 3
  },
  {
    "name": "Hooks & Holders",
    "categoryId": "hooks_holders",
    "parentCategoryName": "Storage",
    "parentCategoryId": "storage",
    "level": 3
  },
  {
    "name": "Laundry Bags",
    "categoryId": "laundry_bags",
    "parentCategoryName": "Storage",
    "parentCategoryId": "storage",
    "level": 3
  },
  
];
